import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImprimirPesosComponent } from './imprimir-pesos.component';
import { ButtonModule } from 'primeng/button';
import {TableModule} from 'primeng/table';



@NgModule({
    declarations: [ImprimirPesosComponent],
    imports: [ 
        CommonModule,
        ButtonModule,
        TableModule 
    ],
    exports: [ ImprimirPesosComponent ],
    providers: [],
})
export class ImprimirPesosSharedModule {}